module.exports = __webpack_public_path__ + "static/logo_google_for_startups@2x-e85d4460fa960469973d52cb4df58ccc.png";